import SiteMessagesInstance from "../components/site-messages";

const forgotPassword = document.querySelector('.forgot-password');

if(forgotPassword) {

  const $resetPassword = $('.reset-password');

  $resetPassword.on('submit', e => {

    e.preventDefault();

    const $button = $resetPassword.find('button[type="submit"]');
    const $message = $resetPassword.find('.reset-password__message');

    $button.attr('disabled', true);

    window.apiRequestNoToken('post', '/complete-reset-password', $resetPassword.serialize()).then(r => {

      if(r.type === 'error') {
        $message.html(r.message);
        $button.attr('disabled', false);
      } else {

        SiteMessagesInstance.addMessage("success", "Please log in with your new password")
        window.logout();

      }

    });

  });

}
